<template>
  <div>
    <!-- TITOLO ARTICOLO ED INFO FORNITORE -->
    <b-row>
      <b-col>
        <!-- Titolo -->
        <h4>{{dati_articolo.descrizione}}</h4>
        <!-- Nome e Cognome fornitore -->
        <h6 class="font-weight-normal">di: <span class="font-italic">{{dati_fornitore.nome}} {{dati_fornitore.cognome}}</span></h6>
        <!-- Indirizzo -->
        <h6 class="font-weight-normal">
          <span class="font-italic">
            {{dati_fornitore.indirizzo}} {{dati_fornitore.comune}} {{dati_fornitore.cap}} <span v-if="dati_fornitore.provincia" class="text-uppercase">({{dati_fornitore.provincia}})</span>
            <b-link class="ml-2" target="_blank" :href="google_map_link" v-b-tooltip.hover.rightbottom="'Vedi in Google Maps'" ><font-awesome-icon icon="map-marker-alt"/></b-link>
          </span>
        </h6>
        <!-- Telefono -->
        <h6 v-if="dati_fornitore.tel" class="font-weight-normal">
          <font-awesome-icon icon="phone-square-alt" class="mr-2"/><i>Telefono:</i> {{dati_fornitore.tel}}
        </h6>
        <!-- Email - Si può escludere dalla visualizzazione con apposita prop -->
        <h6 v-if="dati_fornitore.email && !hide_email" class="font-weight-normal">
          <font-awesome-icon icon="at" class="mr-2"/><i>Email:</i> <b-link :href="'mailto:' + dati_fornitore.email">{{dati_fornitore.email}}</b-link>
        </h6>
        <!-- Sito web: prima si controlla se esiste quello secifico per l'articolo, in alternativa se esiste, si usa quello del fornitore -->
        <div v-if="dati_articolo.sito_web">
          <h6 class="font-weight-normal">
            <font-awesome-icon icon="globe" class="mr-2"/><i>Sito web:</i> <b-link target="_blank" :href="dati_articolo.sito_web">{{dati_articolo.sito_web}}</b-link>
          </h6>
        </div>
        <div v-else>
          <h6 v-if="dati_fornitore.sito_web" class="font-weight-normal">
            <font-awesome-icon icon="globe" class="mr-2"/><i>Sito web:</i> <b-link target="_blank" :href="dati_fornitore.sito_web">{{dati_fornitore.sito_web}}</b-link>
          </h6>
        </div>
      </b-col>
    </b-row>
    <!-- PREZZO, SCONTO E DISPONIBILITA' -->
    <b-row class="mt-3">
      <b-col>
        <h6 class="font-weight-normal">
          <i>Prezzo unitario:</i> <b class="h4">{{dati_articolo.prezzo_unitario}} €</b>
        </h6>
        <h6 v-if="dati_articolo.sconto > 0" class="font-weight-normal">
          <i>Sconto a te riservato:</i> <b-badge class="ml-2" pill variant="success"><span class="h6">{{dati_articolo.sconto}}%</span></b-badge>
        </h6>
        <h6 v-if="dati_articolo.disponibilita_max > 0" class="font-weight-normal">
          <i>Disponibilità massima:</i> {{dati_articolo.disponibilita_max}}
        </h6>
      </b-col>
    </b-row>
    <!-- MODALITA' DI FRUIZIONE ED ALTRE INFO ( SE PRESENTI ) -->
    <b-row class="mt-3">
      <b-col>
        <div v-if="dati_articolo.fruizione != null && dati_articolo.fruizione != ''">
          <h5>Fruizione e/o offerte:</h5>
          <div v-html="dati_articolo.fruizione"></div>
        </div>
        <div v-if="dati_articolo.altre_info!= null && dati_articolo.altre_info != ''">
          <h5>Altre informazioni:</h5>
          <div v-html="dati_articolo.altre_info"></div>
        </div>
      </b-col>
    </b-row>
    <!-- PULSANTE DI ACQUISTO -->
    <b-row>
      <b-col>
        <b-button variant='primary' @click="esegui_acquisto">Acquista</b-button>
      </b-col>
    </b-row>
  </div>
</template>


<script>
/**
 * Il mixin include le due prop fondamentali dati_articolo e dati_fornitore e altri
 * elementi di utilità per tutti i templates come il calcolo della stringa per la
 * ricerca in Google Maps e la funzione di acquisto di default.
 * Dalla funzione di acquisto il componente eredita anche l'emissione di tre eventi che
 * possono essere recepiti dal parent:
 * - onAcqSubmit:   viene emesso all'ok sulla finestra di conferma acquisto.
 * - onAcqComplete: viene emesso se l'acquisto si completa correttamente prima che il messaggio
 *                  di completamento sia visualizzato.
 * - onAcqError:    viene emesso se l'acquisto va in errore, prima della visualizzazione della
 *                  finestra di errore.
 */
import { templateMixin } from '@/components/fornitori/template_articoli/templateMixin'

export default {
  name: 'DefaultTmpl',
  mixins: [ templateMixin ],
  data () {
    return {}
  },
  props : {
    /**
     * Esclude la visualizzazione della mail del fornitore
     */
    hide_email: {
      type: Boolean,
      default: false
    }
  }
}
</script>


<style scoped>
</style>